var _path, _path2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m182.694 332.707 36.653 21.162 36.653 21.161v42.323 42.324l-36.653 21.161-36.653 21.162-36.653-21.162-36.652-21.161v-42.324-42.323l36.652-21.161z",
    fill: "#fb695b",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m329.306 332.707 36.653 21.162 36.652 21.161v42.323 42.324l-36.652 21.161-36.653 21.162-36.653-21.162-36.653-21.161v-42.324-42.323l36.653-21.161z",
    fill: "#fad51b",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m109.389 249.814c4.641-127.252 288.58-127.252 293.222 0v68.569h-139.633c-2.316.083-4.642.13-6.978.13s-4.662-.047-6.978-.13h-139.633z",
    fill: "#4677d5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.114 155.691c62.897 6.552 119.447 37.914 121.497 94.123v68.569h-242.994v-68.569c2.05-56.209 58.599-87.572 121.497-94.123z",
    fill: "#5c85da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.999,
    cy: 87.518,
    fill: "#f0cd9c",
    r: 77.518,
    transform: "matrix(.707 -.707 .707 .707 13.096 206.652)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.363 12.983c32.422 9.276 56.154 39.133 56.154 74.535s-23.732 65.259-56.154 74.535c-32.422-9.276-56.153-39.134-56.153-74.535s23.731-65.259 56.153-74.535z",
    fill: "#f7d8ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 205.737 36.653 21.162 36.653 21.162v42.323 42.323l-36.653 21.161-36.653 21.162-36.653-21.162-36.653-21.161v-42.323-42.323l36.653-21.162z",
    fill: "#60daa8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.306 248.061v42.323 42.323l-36.653 21.161-36.653 21.162v-42.323-42.323l36.653-21.162z",
    fill: "#4ac994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 205.737 36.653 21.162 36.653 21.162-36.653 21.161-36.653 21.162-36.653-21.162-36.653-21.161 36.653-21.162z",
    fill: "#80e0b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.306 332.707 36.653 21.162 36.652 21.161-36.652 21.162-36.653 21.161-36.653-21.161-36.653-21.162 36.653-21.161z",
    fill: "#ffe54e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.694 332.707 36.653 21.162 36.653 21.161-36.653 21.162-36.653 21.161-36.653-21.161-36.652-21.162 36.652-21.161z",
    fill: "#fd7a6e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 375.03v42.323 42.323l-36.653 21.162-36.653 21.162v-42.323-42.324l36.653-21.161z",
    fill: "#e85e51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.611 375.03v42.323 42.323l-36.652 21.162-36.653 21.162v-42.323-42.324l36.652-21.161z",
    fill: "#ffbd1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentInventory);
export default __webpack_public_path__ + "static/media/Agent Inventory.cfd315e6d8aeb98a0adf080af7d952fd.svg";
export { ForwardRef as ReactComponent };